<template>
    <div class="main-content">
        <div class="page-header">
            <h3 class="page-title">Listado de compras</h3>
            <ol class="breadcrumb">
                <li class="breadcrumb-item"><a href="#">Compras</a></li>
                <li class="breadcrumb-item active">Listado de compras</li>
            </ol>
        </div>
        <div class="card">
            <generic-header :textButton='"Nueva compra"' :url='"/admin/compra/nuevo"' :isButton="false" :status='status' :isReadOnly='false' :typeFields="typeFields"
                @change-filter="changeFilter" />
            <!-- <div class="card-header">
                <button type="button" class="btn btn-theme">Nueva compra</button>
            </div> -->
            <div class="card-body">
                <table class="table">
                    <thead>
                        <tr>
                            <th>Documento</th>
                            <th>Comprador</th>
                            <th>Proveedor</th>
                            <th>Total</th>
                            <th>Estado</th>
                            <th>Fecha</th>
                            <th>Fecha de entrega</th>
                            <th>Opciones</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="purchase in purchases" :key="purchase.id">
                            <td>{{purchase.document}}</td>
                            <td>{{purchase.nameBuyer}}</td>
                            <td>{{purchase.companyProvider}}</td>
                            <td>{{mymoney(purchase.total)}}</td>
                            <td>
                                <span class="btn btn-danger btn-sm" v-if="purchase.state===0">Anulado</span>
                                <span class="btn btn-warning btn-sm" v-if="purchase.state===2">Pendiente</span>
                                <span class="btn btn-success btn-sm" v-if="purchase.state===1">Comprobado</span>
                            </td>
                            <td>{{convertDate(purchase.purchase_date)}}</td>
                            <td>{{convertDate(purchase.delivery_date)}}</td>
                            <td class="btn-group mr-2" role="group" aria-label="First group">
                                <button class="btn btn-danger" v-tooltip.top-center="'Anular compra'"
                                    @click="openModal(purchase.id)" v-if="purchase.state!=0">
                                    <i class="icon-fa icon-fa-trash" />
                                </button>
                                <router-link v-tooltip.top-center="'Ver compra'" class="btn btn-success"
                                    :to="`/admin/compra/ver?id=${purchase.id}`">
                                    <i class="icon-fa icon-fa-eye" /></router-link>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="card-footer">
                <ul class="pagination pagination-primary m-b-0">
                    <li class="page-item" v-if="pagination.current_page > 1">
                        <a class="page-link" href="#"
                            @click.prevent="changePage(pagination.current_page - 1, search, critery)"><i
                                class="icon-fa icon-fa-angle-left"></i></a>
                    </li>
                    <li class="page-item" v-for="page in pagesNumber" :key="page"
                        :class="[page == isActived ? 'active' : '']">
                        <a class="page-link" href="#" @click.prevent="changePage(page, search, critery)"
                            v-text="page"></a>
                    </li>
                    <li class="page-item" v-if="pagination.current_page < pagination.last_page">
                        <a class="page-link" href="#"
                            @click.prevent="changePage(pagination.current_page + 1, search, critery)"><i
                                class="icon-fa icon-fa-angle-right"></i></a>
                    </li>
                </ul>
            </div>
        </div>
        <sweet-modal ref="confirm_avoid" icon="info">
            <h6>¿Desea anular la compra?</h6>
            <button slot="button" type="button" class="btn btn-info" @click="tabModalCancel()">
                No
            </button>
            <button slot="button" type="button" class="btn btn-success ladda-button" data-style="expand-right"
                @click="tabModalYes()">
                Si
            </button>
        </sweet-modal>
    </div>
</template>
<script>
    import ladda from "ladda";
    import { SweetModal, SweetModalTab } from 'sweet-modal-vue'
    import { xelacode } from '../../../helpers/xelacode'
    import GenericHeader from '../utils/GenericHeader'
    export default {
        components: {
            SweetModal,
            SweetModalTab,
            'generic-header': GenericHeader
        },
        computed: {
            isActived: function () {
                return this.pagination.current_page;
            },
            pagesNumber: function () {
                if (!this.pagination.to) {
                    return [];
                }
                var from = this.pagination.current_page - this.offset;
                if (from < 1) {
                    from = 1;
                }
                var to = from + (this.offset * 2);
                if (to >= this.pagination.last_page) {
                    to = this.pagination.last_page;
                }
                var pagesArray = [];
                while (from <= to) {
                    pagesArray.push(from);
                    from++;
                }
                return pagesArray;
            },
        },
        data() {
            return {
                allFilter:{
                    filter:'',
                    critery: 'document.name',
                    state: 0,
                    place: 0
                },
                purchases: [],
                user: {},
                idPurchase: 0,
                status: [
                    {
                        label: 'Pendiente',
                        value: 2
                    },
                    {
                        label: 'Comprobado',
                        value: 1
                    },
                    {
                        label: 'Anulado',
                        value: 0
                    }
                ],
                typeFields: [
                    {
                        label: 'Documento',
                        value: 'documents.name'
                    },
                    {
                        label: 'Proveedor',
                        value: 'providers.company'
                    },
                    {
                        label: 'Comprador',
                        value: 'persons.name'
                    },
                ],
                pagination: {
                    'total': 0,
                    'current_page': 0,
                    'per_page': 0,
                    'last_page': 0,
                    'from': 0,
                    'to': 0,
                },
                offset: 3,
            }
        },
        methods: {
            changePage(page, search, critery) {
                let me = this;
                me.pagination.current_page = page;
                me.getPurchases(page);
            },
            openModal(Sale) {
                this.idPurchase = Sale;
                this.$refs.confirm_avoid.open();
            },
            tabModalCancel() {
                this.$refs.confirm_avoid.close();
            },
            tabModalYes() {
                this.voidInvoice();
            },
            getPurchases(page) {
                let vm=this;
                axios.get(`/api/purchase/index?page=${page}&filter=${vm.allFilter.filter}&critery=${vm.allFilter.critery}&status=${vm.allFilter.state}&place=${vm.allFilter.place}`)
                    .then((response) => {
                        vm.purchases = response.data.purchases.data;
                        vm.pagination= response.data.pagination;
                    }).catch((error) => {
                        console.log(error);
                    })
            },
            convertDate(date) {
                var newDate = date.split('-');
                return newDate[2] + '/' + newDate[1] + '/' + newDate[0];
            },
            mymoney(value) {
                return xelacode.money(parseFloat(value));
            },
            getUser() {
                let me = this;
                axios.get('/api/sale/getUser')
                    .then((response) => {
                        me.user = response.data;
                    }).catch((error) => {
                        console.log(error);
                    })
            },
            voidInvoice() {
                let vm = this;
                var l = ladda.create(document.querySelector(".ladda-button"));
                l.start();
                axios.post('/api/purchase/voidInvoice', {
                    id: vm.idPurchase,
                    idUser: vm.user.id
                }).then((response) => {
                    toastr.success(response.data.message, 'Listo');
                    l.stop();
                    vm.getPurchases(1);
                    vm.tabModalCancel();
                }).catch((error) => {
                    console.log(error);
                    l.stop();
                    vm.tabModalCancel();
                });
            },
            changeFilter(filter,critery,state,locate){
                this.allFilter={
                    filter:filter,
                    critery: critery,
                    state: state,
                    place: locate
                }
                this.getPurchases(1);
            }
        },
        mounted() {
            this.getPurchases(1);
            this.getUser();
        }
    }
</script>


// WEBPACK FOOTER //
// resources/js/views/admin/purchase/ListPurchase.vue